import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Cookie } from 'lucide-react';
import { updateConsent } from '../lib/analytics';

const STORAGE_KEY = 'bennaid_cookie_consent';

const ConsentBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'granted') {
      updateConsent(true);
    } else if (stored === 'denied') {
      updateConsent(false);
    } else {
      setVisible(true);
    }
    const reopen = () => setVisible(true);
    window.addEventListener('open-cookie-consent', reopen);
    return () => window.removeEventListener('open-cookie-consent', reopen);
  }, []);

  const choose = (granted) => {
    updateConsent(granted);
    localStorage.setItem(STORAGE_KEY, granted ? 'granted' : 'denied');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 inset-x-0 z-[100] p-4 sm:p-5 animate-in slide-in-from-bottom duration-500"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-center gap-4 bg-black/95 backdrop-blur-xl border border-white/10 p-5 sm:p-6 shadow-2xl">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="w-5 h-5 text-[#00FFD1] shrink-0 mt-0.5" />
          <p className="text-sm text-white/70 leading-relaxed">{t('consent.message')}</p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            data-testid="cookie-decline-button"
            onClick={() => choose(false)}
            className="px-5 py-2.5 text-sm text-white/70 border border-white/15 hover:border-white/30 hover:text-white transition-colors duration-300"
          >
            {t('consent.decline')}
          </button>
          <button
            data-testid="cookie-accept-button"
            onClick={() => choose(true)}
            className="px-5 py-2.5 text-sm font-medium text-black bg-[#00FFD1] hover:bg-[#00e6bd] transition-colors duration-300"
          >
            {t('consent.accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
